import { useEffect, useRef } from 'react';
import { getProgramCountForBudget } from '../services/programService.js';
import { REDUCER_ACTION_TYPES } from '../store/Reducer.js';

const useActiveBudgetProgramCount = (user, dispatch) => {
  const requestId = useRef(0);
  const activeOrganization = user?.activeOrganization;
  const activeBudgetId = user?.activeBudget?.id;

  useEffect(() => {
    const currentRequestId = ++requestId.current;
    dispatch({
      type: REDUCER_ACTION_TYPES.SET_PROGRAM_COUNT_FOR_ACTIVE_BUDGET,
      payload: null,
    });

    if (!activeBudgetId) return;

    getProgramCountForBudget().then(response => {
      if (currentRequestId !== requestId.current) return;

      dispatch({
        type: REDUCER_ACTION_TYPES.SET_PROGRAM_COUNT_FOR_ACTIVE_BUDGET,
        payload: response.data.count,
      });
    });

    return () => {
      requestId.current += 1;
    };
  }, [activeOrganization, activeBudgetId, dispatch]);
};

export default useActiveBudgetProgramCount;
